import Paho from './mqttws31'
import * as Constants from '../common/constants'

class MqttClient {

    constructor() {
        this.mqttClient = null
        this.isConnected = false
        this.autoConnect = true
        this.port = ""
        this.host = ""
        this.clientId = ""
        this.topicSubscribers = []
        this.connectionStatusChangeCallbacks = []
        this.conOpts = null
        this.reconnectCount = 0
        this.reconnecthandle = null
    }

    connect = (conOpts, callback) => {
        if (this.isConnected) {
            throw new Error("Already connected, call disconnect() & then connect()")
        }

        // validate args
        if (!(conOpts.clientId && conOpts.port && conOpts.host && conOpts.autoConnect && conOpts.willData)) {
            throw new Error("Invalid connection option values")
        } else {
            this.clientId = conOpts.clientId
            this.port = conOpts.port  
            this.host = conOpts.host
            this.autoConnect = conOpts.autoConnect
            this.willData = conOpts.willData
            this.willData.payload.client_id = this.clientId
        }

        let mqttClient = new Paho.MQTT.Client(this.host, Number(this.port), this.clientId);
        // set the callback handlers
        mqttClient.onConnectionLost = this._onConnectionLost
        mqttClient.onMessageArrived = this._onMessageArrived

        let willMessage = new Paho.MQTT.Message(JSON.stringify(this.willData.payload))
        willMessage.destinationName = this.willData.topic   
        willMessage.qos = this.willData.qos

        conOpts = {
            timeout: 60, // connect timeout
            onSuccess: (rc) => {
                 this.isConnected = true
                
                //console.log("MqttClient.onConnect: CONNACK ", rc)
                callback(null, {
                    status: "success",
                    data: rc
                })
                this._connectionStatusChange(Constants.MQTT_ONLINE)
            },
            onFailure: (res) => {
                // console.log("MqttClient.onDisconnect: Lost mqttClient ", res.errorCode, ", ",
                // res.errorMessage)
                callback(res.errorMessage, {
                    status: "fail",
                    data: res
                })
            },
            willMessage,
            keepAliveInterval: 30,
            cleanSession: false,
            invocationContext: this,
            useSSL: true
        }
        // connect to mqtt server
        mqttClient.connect(conOpts);

        this.conOpts = conOpts
        this.mqttClient = mqttClient
    }

    disconnect = (res) => {
        console.log(`MqttClient.disconnect called for clientId: ${this.clientId}`)
        
        if (this.isConnected) {
            this.autoConnect = false
            this.mqttClient.disconnect()
            this.mqttClient = null
            this.clientId = ""
            this.isConnected = false
        }
    }

    subscribe = (config, callback) => {
        const topicSubscription = this.topicSubscribers[config.topic]
        if (topicSubscription) {
            this.unsubscribe(config)
            topicSubscription.callbacks.push(config.callback)
        } else {
            let topicSubscription = {
                callbacks: [config.callback]
            }
            this.topicSubscribers[config.topic] = topicSubscription

            this.mqttClient.subscribe(config.topic, {
                qos: config.qos,
                onSuccess: function (rc) {
                    //console.log("MqttClient.subscribe onSuccess ", rc)
                    rc.topic = config.topic
                    callback(null, {
                        status: "success",
                        data: rc
                    })
                },
                onFailure: function (res) {
                    // console.log("MqttClient.subscribe onFailure", res.errorCode, ", ",
                    // res.errorMessage)
                    callback(res.errorMessage, {
                        status: "fail",
                        data: res
                    })
                },
                timeout: 5
            })
        }
    }

    unsubscribe = (config) => {
        const topicSubscription = this.topicSubscribers[config.topic]
        if (topicSubscription) {
            let callbacks = topicSubscription.callbacks.filter((callback) => callback !== config.callback)
            if (callbacks.length === 0) { // if no callback is available then remove the topicSubscription from topicSubscribers list
                delete this.topicSubscribers[config.topic]
            } else { 
                // add the remaining topicSubscription callbacks
                topicSubscription.callbacks = callbacks
            }
        }
    }

    publish = (packet) => {
        this.mqttClient.send(packet.topic, packet.payload, packet.qos)
    }

    addConnectionStatusChangeCallback = (callback) => {
        if (typeof callback === 'function') {
            this.connectionStatusChangeCallbacks.push(callback)
        }
    }

    removeConnectionStatusChangeCallback = (callback) => {
        this.connectionStatusChangeCallbacks = this.connectionStatusChangeCallbacks.filter(c => c !== callback)
    }

    // all private methods
    _onConnectionLost = (res) => {
        console.log("MqttClient._onConnectionLost res: " + res.errorMessage)
        this.isConnected = false
        this._connectionStatusChange(Constants.MQTT_OFFLINE)
        if (this.autoConnect) {
            this.reconnecthandle = setTimeout(()=>{this._reconnect()}, 500 * (2 ^ this.reconnectCount))
        }
    }

    _reconnect = () => {
        console.log('mqttclient reconnecting...' + ++this.reconnectCount)
        clearTimeout(this.reconnecthandle)

        this.conOpts = Object.assign({}, this.conOpts, {
            onSuccess: (res) => {
                //console.log(`_reconnect() JSON.Stringify(${res})`)
                this.isConnected = true
                this.reconnectCount = 0
                this._connectionStatusChange(Constants.MQTT_ONLINE)
            },
            onFailure: (res) => {
                console.log("_reconnect failed: " + res.errorMessage)
                this._onConnectionLost(res)
            }
        })

        this.mqttClient.connect(this.conOpts);
    }

    _onMessageArrived = (packet) => {
        let newPacket = Object.assign({}, packet, {
            topic: packet.destinationName,
            payload: packet.payloadString,
            qos: packet.qos
        })
        //console.log(`_onMessageArrived packet: ${JSON.stringify(packet)}`)
        const topicSubscription = this.topicSubscribers[newPacket.topic]
        if (topicSubscription) {
            topicSubscription.callbacks.forEach((callback) => callback(newPacket))
        }
    }


    _connectionStatusChange = (status) => {
        this.connectionStatusChangeCallbacks.map(callback => callback({clientId:this.clientId, status}))
    }
}

export default MqttClient


// WEBPACK FOOTER //
// ./src/services/mqtt/mqttclient/mqttclient.js